import { watchSteps } from '@/mocks/guide';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function WatchGuide() {
  return (
    <section id="guide" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          tag="观影指南"
          title="四步搞定，从搜索到播放一路顺畅"
          desc="第一次来星辰影院也不用摸索太久，跟着下面几步操作，很快就能找到想看的作品并开始播放。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="relative rounded-2xl overflow-hidden border border-background-200/70 w-full h-[280px] sm:h-[360px] lg:h-[440px] lg:sticky lg:top-28">
            <img
              src="https://readdy.ai/api/search-image?query=cinematic%20stylized%20illustration%20of%20a%20cozy%20living%20room%20with%20a%20large%20screen%20glowing%20warm%20amber%2C%20snacks%20on%20a%20small%20table%2C%20deep%20crimson%20accents%2C%20cozy%20evening%20atmosphere%2C%20minimal%20clean%20composition%2C%20rich%20texture%20high%20detail&width=900&height=900&seq=xc-guide-view&orientation=squarish"
              alt="在家通过大屏观看影视作品的场景示意图"
              title="星辰影院 在线观看 观影指南"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 to-transparent"></div>
            <div className="absolute left-4 right-4 bottom-4">
              <p className="text-background-50 text-sm md:text-base font-medium leading-relaxed">
                无需注册，打开即可观看。进度自动记录，随时接着上次看。
              </p>
            </div>
          </div>

          <ol className="space-y-4">
            {watchSteps.map((step) => (
              <li
                key={step.step}
                className="p-4 md:p-5 rounded-xl bg-background-100/70 border border-background-200/70"
              >
                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 flex-shrink-0 rounded-lg bg-secondary-100 text-secondary-900 flex items-center justify-center">
                    <i className={`${step.icon} text-xl`}></i>
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-xs font-bold text-accent-700">
                        STEP {step.step}
                      </span>
                      <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-2">
                      {step.desc}
                    </p>
                    <ul className="flex flex-wrap gap-x-4 gap-y-1.5 mt-3">
                      {step.points.map((point) => (
                        <li
                          key={point}
                          className="inline-flex items-center gap-1.5 text-[11px] md:text-xs text-foreground-700"
                        >
                          <i className="ri-check-line text-primary-600"></i>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}